import { buildAxonItem, getAxonUserData, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonViewItem() {
  let reported = false

  function reportViewItem(content: { contentId: string; contentName?: string; coverUrl?: string }) {
    if (!content.contentId)
      return
    // 同一进入仅上报一次
    if (reported)
      return
    reported = true

    pushAxonEvent('view_item', {
      currency: 'USD',
      user_data: getAxonUserData(),
      items: [buildAxonItem({
        item_id: content.contentId,
        item_name: content.contentName,
        image_url: content.coverUrl,
        quantity: 1,
      })],
    })
  }

  return { reportViewItem }
}
